import { Grid, type GridProps, Typography } from "@mui/material";
import type { FC } from "react";
import { formatColorDifference } from "service/color-formatting";
import {
  type ColorCieLab,
  deltaAngle,
  deltaE,
  labToLch,
} from "service/color-math";

export interface ColorDifferenceProps extends GridProps {
  value: ColorCieLab;
  target: ColorCieLab;
  includeDeltaE?: boolean;
}

function Label({ children }: any) {
  return (
    <Typography width={30} display="inline-block" variant="label">
      {children}
    </Typography>
  );
}

export const ColorDifference: FC<ColorDifferenceProps> = ({
  value,
  target,
  includeDeltaE = true,
  ...gridProps
}) => {
  const valueLch = labToLch(value);
  const targetLch = labToLch(target);
  const deltaELab = deltaE(value, target);
  const deltaL = value[0] - target[0];
  const deltaA = value[1] - target[1];
  const deltaB = value[2] - target[2];
  const deltaC = valueLch[1] - targetLch[1];
  const deltaH = deltaAngle(valueLch[2], targetLch[2]);

  return (
    <Grid container rowSpacing={0.5} {...gridProps}>
      {includeDeltaE && (
        <Grid size={12}>
          <Label>ΔE*</Label>&nbsp;{formatColorDifference(deltaELab)}
        </Grid>
      )}
      <Grid size={4}>
        <Label>ΔL*</Label>&nbsp;{formatColorDifference(deltaL)}
      </Grid>
      <Grid size={4}>
        <Label>Δa*</Label>&nbsp;{formatColorDifference(deltaA)}
      </Grid>
      <Grid size={4}>
        <Label>Δb*</Label>&nbsp;{formatColorDifference(deltaB)}
      </Grid>
      <Grid size={4}></Grid>
      <Grid size={4}>
        <Label>ΔC*</Label>&nbsp;{formatColorDifference(deltaC)}
      </Grid>
      <Grid size={4}>
        <Label>Δh*</Label>&nbsp;{formatColorDifference(deltaH, "°")}
      </Grid>
    </Grid>
  );
};
